<template>
  <div class="module-table">
    <el-table :data="moduleData" border size="small" class="data-table">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="案号">
            <template slot-scope="scope">
              {{ scope.row.case_number || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="被执行人名称" min-width="180" >
            <template slot-scope="scope">
              {{ scope.row.executee_name }}
            </template>
        </el-table-column>
        <el-table-column label="被执行人状态">
            <template slot-scope="scope">
              {{ scope.row.executee_fulfil_situation || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="负责人姓名">
            <template slot-scope="scope">
              {{ scope.row.leader_name || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="执行标的金额">
            <template slot-scope="scope">
              {{ scope.row.execution_target_amount || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="法院名称（执行者）">
            <template slot-scope="scope">
              {{ scope.row.execution_court_name || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="立案日期">
            <template slot-scope="scope">
              {{ scope.row.filing_time || '-' }}
            </template>
        </el-table-column>
        
    </el-table>
  </div>
</template>

<script>
export default {
    name: 'dishonestExecuteeList',

    data() {
        return {
            title: '失信被执行人',
        }
    },  
    props: {
        moduleData: {
            type: Array,
            default: () => []
        }
    },
    methods: {
    }
}
</script>

<style scoped lang="scss">
// 表格铺满
.module-table {
  width: 100%;
  .el-table { 
    width: 100%;
  }
}
</style>